import { Theme } from '@material-ui/core';
import Popover from '@material-ui/core/Popover';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';
import React, { useState } from 'react';
import ChromePicker from 'react-color/lib/components/chrome/Chrome';

const useStyles = makeStyles<Theme, QRColorPickerPopoverProps>({
	text: {
		width: 254,
		// marginBottom: 20,
		// paddding: 20,
		// marginTop: 10,
	},
	swatch: (props) => ({
		borderRadius: '50%',
		backgroundColor: `${props.color}`,
		width: 17,
		height: 17,
	}),
});

export type QRColorPickerPopoverProps = {
	setColor: (color: string) => void;
	setError: (err: boolean) => void;
	name: string;
	label: string;
	id?: string;
	color?: string; // A HEX color value, i.e. #FF0000
};

const defaultProps = {
	color: '#000000',
};

export const QRColorPickerPopover = (props: QRColorPickerPopoverProps) => {
	const { setColor, name, label, id, color } = { ...defaultProps, ...props };

	const [popoverIsVisible, setPopoverIsVisible] = useState<boolean>(false);
	const [popoverAnchorElement, setPopoverAnchorElement] = useState<HTMLInputElement | null>(null);
	const [selectedColor, setSelectedColor] = useState(color);
	const [error, setError] = useState(false);
	const classes = useStyles({ name, label, color: selectedColor ?? color, setColor, setError });

	const openPopover = (e: React.MouseEvent<HTMLInputElement>) => {
		e.preventDefault();
		setPopoverAnchorElement(e.currentTarget);
		setPopoverIsVisible(true);
	};

	const handleClosePopover = () => {
		setPopoverIsVisible(false);
		setPopoverAnchorElement(null);
	};

	const handleColorChange = (color) => {
		setColor(color.hex);
		setSelectedColor(color.hex);
	};

	const handleColorChangeText = (color) => {
		setColor(color);
		setSelectedColor(color);
	};

	return (
		<>
			<TextField
				size="small"
				error={error}
				className={classes.text}
				value={selectedColor ?? ''}
				variant="outlined"
				id={id}
				name={name}
				label={label}
				onChange={(e) => handleColorChangeText(e.target.value)}
				onClick={openPopover}
				InputLabelProps={{
					shrink: true,
					style: {
						marginTop: 5,
					},
				}}
			/>
			<Popover
				id={`${id}-color-picker`}
				open={popoverIsVisible}
				anchorEl={popoverAnchorElement}
				onClose={handleClosePopover}
			>
				<ChromePicker color={selectedColor} onChange={handleColorChange} />
			</Popover>
		</>
	);
};
